/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Profile_Slot_Generation_TitleInputs */

const en_company_profile_slot_generation_title = /** @type {(inputs: Company_Profile_Slot_Generation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate appointment slots for the job applicants`)
};

const de_company_profile_slot_generation_title = /** @type {(inputs: Company_Profile_Slot_Generation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termine für die Stellenanträge generieren`)
};

/**
* | output |
* | --- |
* | "Generate appointment slots for the job applicants" |
*
* @param {Company_Profile_Slot_Generation_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_profile_slot_generation_title = /** @type {((inputs?: Company_Profile_Slot_Generation_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Profile_Slot_Generation_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_profile_slot_generation_title(inputs)
	return en_company_profile_slot_generation_title(inputs)
});